/**
 * 复盘批注列表（只读）：赛后按时间线回顾教师跟场观察。
 */
import { useArena } from '../../state/ArenaContext.tsx';
import { EmptyState } from '../ui/primitives.tsx';
import { formatTimeOfDay } from '../../export/report.ts';

export function ReviewAnnotations() {
  const { state } = useArena();
  const annotations = [...state.annotations].sort((a, b) => a.at - b.at);

  return (
    <section className="rounded-xl border border-white/10 bg-bg-surface/80 backdrop-blur">
      <header className="border-b border-white/5 px-4 py-3">
        <h2 className="text-sm font-semibold tracking-wide text-slate-100">教师批注回放</h2>
        <p className="mt-0.5 text-xs text-slate-400">共 {annotations.length} 条 · 随战报导出</p>
      </header>
      <div className="p-3">
        {annotations.length === 0 ? (
          <EmptyState title="暂无批注" detail="教练可在教练台随时记录战术观察。" />
        ) : (
          <ol className="space-y-1.5" data-testid="review-annotation-list">
            {annotations.map((annotation) => (
              <li
                key={annotation.id}
                data-testid="review-annotation-item"
                className="rounded-lg border border-white/10 bg-black/20 px-2.5 py-1.5"
              >
                <div className="flex items-center justify-between gap-2 text-[10px] text-slate-500">
                  <span>
                    环节 {annotation.stageIndex > 0 ? annotation.stageIndex : '—'} ·{' '}
                    {annotation.authorName}
                  </span>
                  <span className="mono">{formatTimeOfDay(annotation.at)}</span>
                </div>
                <p className="mt-0.5 whitespace-pre-wrap text-xs text-slate-200">{annotation.text}</p>
              </li>
            ))}
          </ol>
        )}
      </div>
    </section>
  );
}
